module.exports = __webpack_public_path__ + "static/media/fragonard.509a424d.png";